(function() {
var OmsSignaturePad,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

OmsSignaturePad = (function() {
  function OmsSignaturePad() {
    this.initialize_signature_pad = bind(this.initialize_signature_pad, this);
    console.log("OmsSignaturePad: new");
    this.initialize_signature_pad();
  }

  OmsSignaturePad.prototype.initialize_signature_pad = function() {
    var window_ratio;
    window_ratio = Math.max(window.devicePixelRatio || 1, 1);
    return $("div[data-signature-pad='true']").each((function(_this) {
      return function(index, element) {
        var $canvas, $canvas_elem, $clear_button, $data_field, $signature_wrapper, resize_canvas, signaturePad;
        $signature_wrapper = $(element);
        $data_field = $signature_wrapper.find("input.sig_pad_data");
        $canvas_elem = $signature_wrapper.find("canvas");
        $canvas = $canvas_elem.get(0);
        $clear_button = $signature_wrapper.find(".clear_sig_btn");
        signaturePad = new SignaturePad($canvas, function() {
          return {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            penColor: 'rgb(0, 0, 0)'
          };
        });
        signaturePad.onEnd = function(event) {
          var _data;
          $data_field.val("");
          _data = signaturePad.toDataURL("image/svg+xml");
          return $data_field.val(_data);
        };
        $clear_button.get(0).addEventListener('click', function(event) {
          $data_field.val("");
          return signaturePad.clear();
        });
        resize_canvas = function(event) {
          $canvas.width = $canvas.offsetWidth * window_ratio;
          $canvas.height = $canvas.offsetHeight * window_ratio;
          $canvas.getContext("2d").scale(window_ratio, window_ratio);
          return signaturePad.fromData(signaturePad.toData());
        };
        window.removeEventListener('resize', resize_canvas);
        window.addEventListener('resize', resize_canvas);
        resize_canvas();
        return signaturePad.fromDataURL($data_field.val());
      };
    })(this));
  };

  return OmsSignaturePad;

})();

window.alpha_oms.oms_signature_pad_construcutor = OmsSignaturePad;

}).call(window);
